import { CarvanaEmblem } from '@carvana/ds-icons';
import React from 'react';
import styles from './checkout-footer.module.css';

const CheckoutFooter: React.FC = () => (
  <footer className={styles.footer}>
    <CarvanaEmblem className={styles.logo} />
    <p className={styles.copyright}>
      Copyright © {new Date().getFullYear()} Carvana, LLC. All Rights Reserved.
    </p>
  </footer>
);

export default CheckoutFooter;
